module.exports = __webpack_public_path__ + "static/understanding-exposure-b68382e5e62ce643634ae5d29db015fc.jpg";